import { ACCOUNT_MASTER_FORM_RESET, CREATE_ACCOUNT_MASTER_FORM, CREATE_ACCOUNT_MASTER_FORM_FAILURE, CREATE_ACCOUNT_MASTER_FORM_REQUEST, CREATE_ACCOUNT_MASTER_FORM_SUCCESS, DELETE_ACCOUNT_MASTER_FORM_FAILURE, DELETE_ACCOUNT_MASTER_FORM_REQUEST, DELETE_ACCOUNT_MASTER_FORM_SUCCESS, FETCH_ALL_ACCOUNT_MASTER_FAILURE, FETCH_ALL_ACCOUNT_MASTER_REQUEST, FETCH_ALL_ACCOUNT_MASTER_SUCCESS, FETCH_SINGLE_ACCOUNT_MASTER_FORM_FAILURE, FETCH_SINGLE_ACCOUNT_MASTER_FORM_REQUEST, FETCH_SINGLE_ACCOUNT_MASTER_FORM_SUCCESS, UPDATE_ACCOUNT_MASTER_FORM_FAILURE, UPDATE_ACCOUNT_MASTER_FORM_REQUEST, UPDATE_ACCOUNT_MASTER_FORM_SUCCESS } from "./accountMaster.actionType";


export const ACCOUNT_MASTER = 'accountMaster';

let initialState = {
    loading: false,
    accountMasterFormList: [],
    accountMasterForm: {},
    selectedRow: {},
    accountMasterFormSingleData: [],
    detailsId: '',
    activeKey: 1,
    DeleteFormData: '',
    gridPageIndex: 0,
    isAccountMaster: false,
    accountMasterSelectedValue: null,

};

export let accountMasterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ALL_ACCOUNT_MASTER_REQUEST:
        case CREATE_ACCOUNT_MASTER_FORM_REQUEST:
        case FETCH_SINGLE_ACCOUNT_MASTER_FORM_REQUEST:
        case UPDATE_ACCOUNT_MASTER_FORM_REQUEST:
        case DELETE_ACCOUNT_MASTER_FORM_REQUEST:

            return {
                ...state,
                loading: true
            };

        case FETCH_ALL_ACCOUNT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                accountMasterFormList: updatePayload
            };
        case CREATE_ACCOUNT_MASTER_FORM:
            return {
                ...state,
                loading: false,
                accountMasterForm: {
                    ...state.accountMasterForm,
                    [payload.key]: payload.value
                },

            };
        case CREATE_ACCOUNT_MASTER_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                accountMasterForm: updatePayload
                
            };

        case FETCH_SINGLE_ACCOUNT_MASTER_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                accountMasterForm: updatePayload,
                selectedRow: updatePayload,
                activeKey: 1,
            };

        case UPDATE_ACCOUNT_MASTER_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                accountMasterForm: updatePayload,
                detailsId: ''
            };
        case DELETE_ACCOUNT_MASTER_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                DeleteFormData: updatePayload
            };

        case FETCH_ALL_ACCOUNT_MASTER_FAILURE:
        case CREATE_ACCOUNT_MASTER_FORM_FAILURE:
        case FETCH_SINGLE_ACCOUNT_MASTER_FORM_FAILURE:
        case UPDATE_ACCOUNT_MASTER_FORM_FAILURE:
        case DELETE_ACCOUNT_MASTER_FORM_FAILURE:
            return {
                ...state,
                loading: false
            };
        case ACCOUNT_MASTER_FORM_RESET:
            return {
                ...state,
                accountMasterForm: {},
                detailsId: '',
                activeKey: 1
            };


        default:
            return state;
    }
};
